module.exports = __webpack_public_path__ + "media/images/workation-three-0875f4e2ff4984656a5544252005950e.png";